<template>
  <div class="relative inline-block">
    <button class="p-0 m-0"
      @click="toggleDropdown" aria-label="Account"
    >
      <account-icon></account-icon>
    </button>

    <on-click-outside :handler="closeDropdown"
      v-show="showDropdown"
      class="origin-top-right absolute right-0 mt-2 w-64 shadow-lg">
      <section class="border border-gray-400 bg-white ring-1 ring-black ring-opacity-5 px-8 py-10" aria-label="Account">
        <div v-if="!authenticated">
          <login v-on:close="closeDropdown"></login>
        </div>
        <div class="flex flex-col text-center" v-if="authenticated">
          <div class="text-xs text-blackish mb-3" :class="fontHairline()">
            {{ $t('login.welcome') }} <span class="font-bold">{{ user.name }}</span>
          </div>
          <ul>
            <li v-if="customer">
              <router-link to="/profile/orders" @click.native="toggleDropdown">
                {{ $t('profile.orders') }}
              </router-link>
            </li>
            <li>
              <router-link to="/profile" @click.native="toggleDropdown">
                {{ $t('profile.profile') }}
              </router-link>
            </li>
            <li v-if="customer">
              <router-link to="/profile/addresses" class="uppercase" @click.native="toggleDropdown">
                {{ $t('profile.addresses') }}
              </router-link>
            </li>
            <li v-if="customer">
              <router-link to="/profile/coupons" class="uppercase" @click.native="toggleDropdown">
                {{ $t('profile.coupons') }}
              </router-link>
            </li>
          </ul>
          <button class="w-full bg-blackish text-white py-1 mb-3 cursor-pointer" @click="logout">
            {{ $t('login.logout') }}
          </button>
        </div>
      </section>
    </on-click-outside>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AccountIcon from '@/components/graphics/AccountIcon.vue';
import Login from '@/components/Login.vue';
import OnClickOutside from '@/directives/OnClickOutside';

export default {
  data() {
    return {
      showDropdown: false,
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      customer: 'auth/customer',
    }),
  },

  components: {
    AccountIcon,
    Login,
    OnClickOutside,
  },

  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
    }),
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    async logout() {
      await this.signOut().then(() => {
        this.$router.push('/').catch(() => {});
        this.createNotification('info', `${this.$t('notifications.noMoreLoggedIn')}`);
      });
    },

    closeDropdown() {
      this.showDropdown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  @apply mb-3;

  li {
    @apply font-bold text-blackish text-xs tracking-wide py-2 uppercase;
  }
}
</style>
